import { render } from "./DaycareOrder.vue?vue&type=template&id=484bbf27&scoped=true"
import script from "./DaycareOrder.vue?vue&type=script&lang=js"
export * from "./DaycareOrder.vue?vue&type=script&lang=js"

import "./DaycareOrder.vue?vue&type=style&index=0&id=484bbf27&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484bbf27"]])

export default __exports__